import { render, staticRenderFns } from "./ShiftForCapitals.vue?vue&type=template&id=0c67caf4&scoped=true&"
import script from "./ShiftForCapitals.vue?vue&type=script&lang=js&"
export * from "./ShiftForCapitals.vue?vue&type=script&lang=js&"
import style0 from "./ShiftForCapitals.vue?vue&type=style&index=0&id=0c67caf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c67caf4",
  null
  
)

export default component.exports